import { useState } from "react";
import "../styles/login.css";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logoEU.png";
import { API_BASE_URL } from "../config";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [pending, setPending] = useState(false);
    const navigate = useNavigate();
    const sessionExpired = new URLSearchParams(window.location.search).has("expired");

    async function handleLogin(e) {
        e.preventDefault();
        setError("");
        setPending(true);

        try {
            const response = await fetch(
                `${API_BASE_URL}/api/login`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email, password }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                setError(data.detail || "Credenciales incorrectas");
                return;
            }

            localStorage.setItem("token", data.access_token);
            localStorage.setItem("chrona_token", data.chrona_token ?? "");
            navigate("/dashboard");

        } catch (err) {
            console.error(err);
            setError("Error de conexión con el servidor");
        } finally {
            setPending(false);
        }
    }

    return (
        <div className="login-container">
            <div className="login-card">

                <div className="login-card-header">
                    <img src={logo} alt="Orka Logo" />
                    <h1>Orka Management Only</h1>
                    <p>Sign in to continue</p>
                </div>

                <form className="login-card-content" onSubmit={handleLogin}>

                    {sessionExpired && !error && (
                        <div className="error" style={{
                            background: "#fffbeb",
                            border: "1px solid #fde68a",
                            color: "#92400e",
                            marginBottom: 14,
                        }}>
                            Your session expired — please log in again.
                        </div>
                    )}

                    <div className="login-field">
                        <label htmlFor="email">Email</label>
                        <input
                            id="email"
                            type="email"
                            autoComplete="username"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>

                    <div className="login-field">
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            type="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {error && <p className="error">{error}</p>}

                    <button type="submit" disabled={pending}>
                        {pending ? "Signing in…" : "Sign in"}
                    </button>

                </form>
            </div>
        </div>
    );
}